export enum TechnicalDocumentationKeys {
	DELETE_ME_JUST_FOR_TEST = 'TEST',
}
